import React from "react";
import { Route } from "react-router-dom";
import AccountentRoutes from "./Accountent/Accountent.routes";
import CashInFlowRoutes from "./CashInFlow/CashInFlow.routes";
import CashOutFlowRoutes from "./CashOutFlow/CashOutFlow.routes";

const Financial = (
  <Route path="finance/*">
    Financial
    <Route path="*" element={<div>Not Found</div>} />
    {AccountentRoutes}
    {CashInFlowRoutes}
    {CashOutFlowRoutes}
  </Route>
);

export default Financial;
